import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
} from "@syncfusion/ej2-react-grids";

export default function CategoryGrid({ data = [] }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "Category_List_GridID_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="Category_List_GridID"
              dataSource={data}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"350px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="150"
                  textAlign="Center"
                  isPrimaryKey={true}
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="Division"
                  headerText="Division"
                  width="200"
                  textAlign="Left"
                  isPrimaryKey={true}
                />
                <ColumnDirective
                  field="DivisionName"
                  headerText="Division Name"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Department"
                  headerText="Department"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="DepartmentName"
                  headerText="Department Name"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="GroupCategory"
                  headerText="Group Category"
                  width="220"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="GroupCategoryName"
                  headerText="Group Category Name"
                  width="280"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Category"
                  headerText="Category"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="CategoryName"
                  headerText="Category Name"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="SubCategory"
                  headerText="Sub Category"
                  width="220"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="SubCategoryName"
                  headerText="Sub Category Name"
                  width="280"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="McCategory"
                  headerText="MC Category"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="McCategoryDescription"
                  headerText="MC Category Description"
                  width="300"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UploadedOn"
                  headerText="Uploaded On"
                  width="220"
                  textAlign="Center"
                  type="date"
                  format="dd/MM/yyyy"
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>
    </>
  );
}
